const styles = {
  termosContrato: {
    '& p': {
      breakInside: 'avoid',
      textAlign: 'justify'
    },
    '& div': {
      breakInside: 'avoid'
    }
  },  
  [`@page`]: {
    size: 'A4',
    margin: '0cm'
  },
  ['@media print']: {
    pageBreak: { 
      breakInside: 'avoid' 
    }
  }
};

export default styles;